<template>
  <div
    id="#step-3"
    class="fade-in-fwd text-center"
    v-if="getSelectedProduct && getSelectedProduct.colors.length > 0"
  >
    <div class="mt-2 mb-2">
      <div class="d-flex justify-content-end pl-1 pr-2 mb-1">
        <button
          @click="selectAllColors"
          type="button"
          class="btn black hover-red transition-color medium text-size-small"
        >
          {{ areAllColorsSelected? $resourceString["myProject.Project.AddItemModal.ProductStep3.UnselectAll.Label"] : $resourceString["myProject.Project.AddItemModal.ProductStep3.SelectAll.Label"] }}
        </button>
      </div>
      <div class="swatch-image-section row">
        <div
          class="col-3 swatch-image-item px-1"
          v-for="color in step3"
          :key="color.id"
        >
          <button
            @click="updateColor(color)"
            type="button"
            class="btn wf-product-room-scene-color-item-button"
            :class="{
              'wf-product-room-scene-color-item-button-active': isSelected(
                color
              ),
              'wf-product-room-scene-color-item-button-disabled': !color.colorNumber
            }"
          >
            <img :src="color.imagePath?color.imagePath:color.imageLink" alt="" class="w-100 h-100" />
            <div class="wf-product-room-scene-color-item-name">
              {{ color.colorName }}
              <br />
              {{ color.colorNumber }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
<div v-else class="container mb-5 mt-5">
  <p class="">{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      step3: [],
      selectedColors: []
    };
  },

  computed: {
    ...mapGetters({
      getContentWizardData: "contentWizard/getContentWizardData",
      getSelectedProduct: "contentWizard/getSelectedProduct"
    }),

    areAllColorsSelected() {
      return (
        this.selectedColors.length === this.getSelectedProduct?.colors.length
      );
    }
  },

  created() {
    this.step3 = this.getSelectedProduct?.colors;
    const editedItem = this.getContentWizardData.step3;
    if (editedItem) {
      this.selectedColors = editedItem;
    }
  },

  mounted() {
    if (
      this.getContentWizardData.productItemDetails?.productContentItem
        ?.productStyleImages.length > 0
    ) {
      let colors = this.getContentWizardData.productItemDetails
        ?.productContentItem?.productStyleImages;

      this.selectedColors = colors.map(color => ({
        colorNumber: color.colorNumber,
        colorName: color.colorName,
        imageLink: color.imageLink,
        coverImageLink: "",
        attributes: {
          varCode: null
        }
      }));
    }
  },

  watch: {
    selectedColors: {
      handler: function() {
        this.setStep3(this.selectedColors);
      },
      deep: true
    }
  },

  methods: {
    ...mapActions({
      setStep3: "contentWizard/setStep3"
    }),

    updateColor(color) {
      if (this.isSelected(color)) {
        this.selectedColors = this.selectedColors.filter(
          selectedColor => selectedColor.colorNumber !== color.colorNumber
        );
      } else {
        this.selectedColors.push({
          colorNumber: color.colorNumber,
          colorName: color.colorName,
          imageLink: color.imagePath,
          coverImageLink: "",
          attributes: {
            varCode: null
          }
        });
      }
    },
    isSelected(color) {
      return this.selectedColors.some(
        selectedColor => selectedColor.colorNumber === color.colorNumber
      );
    },
    selectAllColors() {
      if (this.selectedColors.length === this.step3.length) {
        this.selectedColors = [];
      } else {
        this.selectedColors = this.step3.map(color => ({
          colorNumber: color.colorNumber,
          colorName: color.colorName,
          imageLink: color.imagePath,
          coverImageLink: "",
          attributes: {
            varCode: null
          }
        }));
      }
    }
  }
};
</script>
